import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getProjectNameHeader } from '@/utils/imUtils';

const baseUrl = envConfig.formalServer + '/plat/admin/im/friend/request/';

function baseApi() {

    function query(data, projectName) {
        return Post(baseUrl + 'queryImFriendshipRequest', data, getProjectNameHeader(projectName));
    }

    return {
        query
    };
}

export const imFriendRequestApi = baseApi();
